import { Button, ButtonGroup, Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import RoundIconComponent from "../../RoundIconComponent";
import React, { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../../utils/snackbarConfig";

const VehicalTypeCard = React.memo((props) => {
  const { t } = useTranslation();

  const [counter, setCounter] = useState(0);
  const [counterPrice, setCounterPrice] = useState(0);

  useEffect(() => {
    props.onUpdatePrice({ price: counterPrice, selected: counter });
  }, [counterPrice, counter]);

  useEffect(() => {
    if (props?.selectedCount) {
      setCounter(props?.selectedCount);
      setCounterPrice(props?.totalCost);
    }
  }, [props?.selectedCount]);

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Box sx={{ width: 48, height: 48, borderRadius: 1.5, flexShrink: 0 }}>
        {" "}
        <RoundIconComponent children={props?.children} />
      </Box>

      <Box sx={{ minWidth: 100, flexGrow: 1 }}>
        <Typography color="inherit" variant="h6" underline="hover" noWrap>
          {props.type}
        </Typography>

        {props?.spotLimit <= 0 ? (
          <Typography variant="body2" color={"red"} fontWeight={"bold"} noWrap>
            {` ${t("pages.reservationType.text15")}`}
          </Typography>
        ) : (
          <Typography
            variant="body2"
            sx={{
              color: props?.spotThresholdData?.thresholdExceeded
                ? "red"
                : "text.secondary",
              wordBreak: "break-word",
              whiteSpace: "normal",
              lineHeight: 1.2,
              mt: 0.5,
            }}
          >
            {props?.spotThresholdData?.thresholdExceeded
              ? `${t("pages.reservationType.text16")}`
              : `${props?.spotLimit} ${t("pages.reservationType.text02")}`}
          </Typography>
        )}
        <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
          {`$ ${props?.chargePerDay}`}
        </Typography>
      </Box>

      <Box>
        <ButtonGroup size="small" aria-label="small outlined button group">
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#DBE5F4",
              borderColor: "#1D5AB9",
              height: "30px",
              borderRadius: "5px",
              color: "primary.main",
              "&:hover": {
                boxShadow: "none",
                background: "#DBE5F4",
              },
              "&:active": {
                boxShadow: "none",
                background: "#DBE5F4",
              },
            }}
            disabled={
              counter <= 0 || props?.spotThresholdData?.thresholdExceeded
            }
            onClick={() => {
              setCounter((counter) => counter - 1);
              if (counterPrice > 0) {
                setCounterPrice((price) => price - props?.price);
              }
            }}
          >
            -
          </Button>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#ffffff",
              borderColor: "#1D5AB9",
              height: "30px",
              borderRadius: "5px",
            }}
            disabled
          >
            {counter}
          </Button>
          <Button
            variant="outlined"
            // disabling the plus sign if counter is equal to 10 or there is no available slops.
            disabled={
              props?.spotLimit <= 0 ||
              props?.totalCount >= 10 ||
              props?.spotThresholdData?.thresholdExceeded
            }
            sx={{
              backgroundColor: "#DBE5F4",
              borderColor: "#1D5AB9",
              color: "primary.main",
              height: "30px",
              borderRadius: "5px",
              "&:hover": {
                boxShadow: "none",
                background: "#DBE5F4",
              },
              "&:active": {
                boxShadow: "none",
                background: "#DBE5F4",
              },
            }}
            onClick={() => {
              console.log(
                "props?.spotLimit,props?.spotLimit",
                props?.spotLimit,
                counter,
              );

              if (props?.spotLimit && props?.spotLimit !== 0) {
                setCounter((counter) => counter + 1);
                setCounterPrice((price) => price + props?.price);
              } else {
                enqueueSnackbar(`Insufficient available spots`, {
                  variant: "error",
                  autoHideDuration: 3000,
                  action: SnackbarConfig,
                });
              }
            }}
          >
            +
          </Button>
        </ButtonGroup>

        <Grid container justifyContent="flex-end">
          <Typography variant="h6" alignSelf={"flex-end"}>
            {`$ ${props?.totalCost.toFixed(2)}`}
          </Typography>
        </Grid>
      </Box>
    </Stack>
  );
});

export default VehicalTypeCard;
